import React from 'react';
import { Tooltip } from '../tooltip';

/**
 * Wraps a disabled control so hovering explains why it is disabled.
 *
 * Lives in core because both apps need it: the support console uses it for the payers work,
 * and the provider claim detail uses it for the credentialing fields the API cannot back.
 *
 * The span is required: MUI's Tooltip listens on its child, and a `disabled` button emits no
 * pointer events, so without a wrapper the hint never appears — leaving a dead control and no
 * explanation.
 *
 * Two rules these follow, because this is a claims console:
 *
 * 1. **Genuinely disabled, not decorative** — `disabled` on the control, so it is unclickable
 *    and reachable-but-skipped by a screen reader, not a live control that silently does
 *    nothing.
 * 2. **No invented data behind them.** Nothing renders a count, a queue length or a status. An
 *    operator who reads a value acts on it, and there is no value to read yet (NS-4).
 */
export interface IComingSoonProps {
    /** What the feature will do, phrased for an operator. */
    hint: string;
    children: React.ReactElement;
}

export function ComingSoon({ hint, children }: IComingSoonProps): React.ReactElement {
    return (
        <Tooltip direction="top" variant="dark" title={<span>{`Coming soon — ${hint}`}</span>}>
            <span style={{ display: 'inline-flex' }}>{children}</span>
        </Tooltip>
    );
}
